import { render } from "./FileScrubber.vue?vue&type=template&id=bb210f22"
import script from "./FileScrubber.vue?vue&type=script&lang=js"
export * from "./FileScrubber.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/benComms/FileScrubber.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bb210f22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bb210f22', __exports__)) {
    api.reload('bb210f22', __exports__)
  }
  
  module.hot.accept("./FileScrubber.vue?vue&type=template&id=bb210f22", () => {
    api.rerender('bb210f22', render)
  })

}


export default __exports__